(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["paw-interactions"] && !Shopify.designMode) return;
  try {
    
(() => {
  if (window.PawHabit) return;
  const money = (cents, currency = 'USD') => new Intl.NumberFormat(document.documentElement.lang || 'en', {style:'currency',currency}).format(cents / 100);
  const runtime = () => document.querySelector('.ph-runtime');
  const root = () => runtime()?.dataset.pawRoot || '/';
  const sections = () => [...new Set([...document.querySelectorAll('cart-items-component')].map(el => el.dataset.sectionId).filter(Boolean))].slice(0,5);
  async function request(path, data) {
    const res = await fetch(root()+path, {method:data?'POST':'GET',headers:{'Content-Type':'application/json',Accept:'application/json'},credentials:'same-origin',...(data?{body:JSON.stringify(data)}:{})});
    const body = await res.json();
    if(!res.ok || body.status >= 400) throw new Error(body.description || body.message || runtime()?.dataset.pawError);
    return body;
  }
  async function updateCart(items, code, source) {
    if(window.PawHabit.busy) return false;
    window.PawHabit.busy = true;
    let eventPromise, CartEvent;
    try {
      const mod = await import('@shopify/events'); CartEvent = mod.CartLinesUpdateEvent;
      eventPromise = CartEvent.createPromise();
      source.dispatchEvent(new CartEvent({action:items.length?'add':'update',context:'product',lines:items.map(i=>({merchandiseId:String(i.id),quantity:i.quantity})),promise:eventPromise.promise}));
      let response = items.length ? await request('cart/add.js',{items,sections:sections(),sections_url:location.pathname}) : null;
      let cart = await request('cart.js');
      let discountWarning = false;
      if(code) {
        const existing = (cart.discount_codes || []).filter(d=>d.applicable).map(d=>d.code);
        const codes = [...new Set([...existing,code])].join(',');
        try {
          response = await request('cart/update.js',{discount:codes,sections:sections(),sections_url:location.pathname});
          cart = response;
          discountWarning = !(cart.discount_codes || []).some(d=>d.code.toLowerCase()===code.toLowerCase() && d.applicable);
        } catch { discountWarning = true; }
      }
      if(!response?.sections) response = await request('cart/update.js',{sections:sections(),sections_url:location.pathname});
      eventPromise.resolve({cart:CartEvent.createCartFromAjaxResponse(cart),detail:{items:cart.items,sections:response.sections,source:'paw-habit',sourceId:source.id,itemCount:items.reduce((s,i)=>s+i.quantity,0),didError:false}});
      if(items.length && !document.querySelector('#cart-drawer')) location.assign(runtime()?.dataset.pawCart || root()+'cart');
      if(discountWarning) {
        const error=source.querySelector('[data-error]');
        if(error){error.hidden=false;error.textContent=runtime()?.dataset.discountWarning;}
      }
      return true;
    } catch(error) {
      eventPromise?.reject(error);
      throw error;
    } finally { window.PawHabit.busy=false; }
  }
  window.PawHabit={money,updateCart,busy:false};

  const motionPreference=matchMedia('(prefers-reduced-motion:reduce)');
  const motionSeen=new WeakSet();
  let motionObserver;
  function initMotion(scope=document){
    const enabled=runtime()?.dataset.pawMotion!=='false'&&!motionPreference.matches;
    document.documentElement.classList.toggle('ph-motion',enabled);
    if(!enabled){motionObserver?.disconnect();document.getAnimations().filter(a=>a.id==='paw-reveal').forEach(a=>a.cancel());return;}
    if(!('IntersectionObserver' in window))return;
    motionObserver??=new IntersectionObserver(entries=>entries.forEach(entry=>{
      if(!entry.isIntersecting)return;
      const el=entry.target;motionObserver.unobserve(el);
      const animation=el.animate([{opacity:0.35,transform:'translateY(16px)'},{opacity:1,transform:'translateY(0)'}],{duration:620,easing:'cubic-bezier(.2,.7,.2,1)'});animation.id='paw-reveal';
    }),{threshold:0.12});
    scope.querySelectorAll('.ph-home-hero__copy,.ph-home-hero__visual,.pet-essentials__header,.pet-essential,.ph-home-set__photos,.ph-home-set__copy,.ph-catalog__intro,.ph-catalog-card,.ph-problem-grid>*,.ph-review-card').forEach(el=>{if(!motionSeen.has(el)){motionSeen.add(el);motionObserver.observe(el);}});
  }
  initMotion();
  document.addEventListener('shopify:section:load',()=>initMotion());
  motionPreference.addEventListener('change',()=>initMotion());

  class PawProduct extends HTMLElement {
    connectedCallback(){
      if(this.dataset.ready) return; this.dataset.ready='true';
      this.variants=JSON.parse(this.querySelector('[data-paw-variants]').textContent);this.labels=JSON.parse(this.querySelector('[data-paw-labels]').textContent);this.form=this.querySelector('.ph-form');
      const offer=new URL(location.href).searchParams.get('offer');if(offer==='pair'||offer==='duo'){const option=this.querySelector('[name="paw_offer"][value="'+offer+'"]');if(option)option.checked=true;}
      this.addEventListener('change',()=>this.update());
      this.addEventListener('input',e=>{if(e.target.name==='quantity') this.update();});
      this.addEventListener('click',e=>{
        const track=this.querySelector('.ph-gallery__track'),motion=matchMedia('(prefers-reduced-motion:reduce)').matches?'instant':'smooth';
        const step=e.target.closest('[data-gallery-step]');if(step)track.scrollBy({left:track.clientWidth*Number(step.dataset.galleryStep),behavior:motion});
        const thumb=e.target.closest('[data-gallery-index]');if(thumb)track.scrollTo({left:track.clientWidth*Number(thumb.dataset.galleryIndex),behavior:motion});
        const qty=e.target.closest('[data-qty]');if(qty){const field=this.form.elements.quantity;field.value=Math.max(1,Math.min(10,(Number(field.value)||1)+Number(qty.dataset.qty)));this.update();}
      });
      this.form.addEventListener('submit',async e=>{
        e.preventDefault();const state=this.state();if(!state.available||window.PawHabit.busy)return;
        const button=this.querySelector('[data-add]'),error=this.querySelector('[data-error]');button.disabled=true;error.hidden=true;this.querySelector('[data-add-label]').textContent=this.labels.adding;
        try { const done=await updateCart(state.items,state.offer==='single'?'':this.dataset.code,this); if(done)this.querySelector('[data-add-label]').textContent=this.labels.added; }
        catch(err){error.hidden=false;error.textContent=err.message||this.labels.error;}
        finally {this.update();}
      });this.update();
      const track=this.querySelector('.ph-gallery__track'),thumbs=[...this.querySelectorAll('[data-gallery-index]')];
      const gallerySync=()=>{const index=Math.min(thumbs.length-1,Math.max(0,Math.round(track.scrollLeft/track.clientWidth)||0));thumbs.forEach((b,i)=>b.setAttribute('aria-current',String(i===index)));this.querySelector('[data-gallery-count]').textContent=(index+1)+' / '+thumbs.length;this.querySelector('[data-gallery-step="-1"]').disabled=index===0;this.querySelector('[data-gallery-step="1"]').disabled=index>=thumbs.length-1;};
      track.addEventListener('scroll',gallerySync,{passive:true});this.galleryObserver=new ResizeObserver(gallerySync);this.galleryObserver.observe(track);gallerySync();
    }
    disconnectedCallback(){this.galleryObserver?.disconnect();delete this.dataset.ready;}
    state(){
      const v=this.variants.find(v=>String(v.id)===String(this.form.elements.id.value))||this.variants[0];
      const qty=Math.max(1,Math.min(10,Number(this.form.elements.quantity.value)||1));
      const offer=this.querySelector('[name="paw_offer"]:checked')?.value||'single';
      const items=[{id:v.id,quantity:offer==='duo'?2:qty}];if(offer==='pair') {items[0].quantity=1;items.push({id:Number(this.dataset.pair),quantity:1});}
      const original=offer==='pair'?v.price+Number(this.dataset.pairPrice):v.price*items[0].quantity;
      const total=original-(offer==='single'?0:Number(this.dataset.saving));
      const available=v.available&&(offer!=='pair'||this.dataset.pairAvailable==='true')&&(v.policy!=='deny'||!v.tracked||v.inventory>=items[0].quantity);
      return {v,qty,offer,items,original,total,available};
    }
    update(){
      const s=this.state(),format=c=>money(c,this.dataset.currency);
      this.querySelector('[data-price]').textContent=format(s.v.price);
      const compare=this.querySelector('[data-compare]'),save=this.querySelector('[data-saving-label]');compare.hidden=save.hidden=!(s.v.compare>s.v.price);compare.textContent=format(s.v.compare);save.textContent=this.labels.save+' '+format(s.v.compare-s.v.price);
      this.querySelector('[data-order-total]').textContent=format(s.total);
      this.querySelector('[data-add]').disabled=!s.available;this.querySelector('[data-add-label]').textContent=s.available?this.labels.add:this.labels.unavailable;
      const express=this.querySelector('[data-express]');if(express)express.hidden=s.offer!=='single'||!s.available;
      this.querySelector('.ph-qty-row').hidden=s.offer!=='single';
      const stock=this.querySelector('[data-stock]');stock.hidden=!(s.v.tracked&&s.v.policy==='deny'&&s.v.inventory>0&&s.v.inventory<=Number(this.dataset.lowStock));stock.textContent=this.labels.lowStock.replace('[count]',String(s.v.inventory));
      const url=new URL(location.href);url.searchParams.set('variant',String(s.v.id));history.replaceState(null,'',url);
    }
  }
  class PawReviews extends HTMLElement {
    connectedCallback(){if(this.dataset.ready)return;this.dataset.ready='true';const track=this.querySelector('.ph-review-track'),filter=this.querySelector('[data-review-filter]');
      this.addEventListener('click',e=>{const b=e.target.closest('[data-review-step]');if(b)track.scrollBy({left:track.clientWidth*Number(b.dataset.reviewStep)*0.9,behavior:matchMedia('(prefers-reduced-motion:reduce)').matches?'instant':'smooth'});});
      const sync=()=>{this.querySelectorAll('.ph-review-card').forEach(card=>card.hidden=filter.value!=='all'&&card.dataset.rating!==filter.value);const total=this.querySelectorAll('.ph-review-card:not([hidden])').length;this.querySelector('[data-review-status]').textContent=total+' '+this.dataset.countLabel;};
      filter.addEventListener('change',()=>{sync();track.scrollLeft=0;nav();});sync();
      const nav=()=>{this.querySelector('[data-review-step="-1"]').disabled=track.scrollLeft<2;this.querySelector('[data-review-step="1"]').disabled=track.scrollLeft+track.clientWidth>=track.scrollWidth-2;};track.addEventListener('scroll',nav,{passive:true});this.observer=new ResizeObserver(nav);this.observer.observe(track);nav();
    }
    disconnectedCallback(){this.observer?.disconnect();}
  }
  if(!customElements.get('paw-product'))customElements.define('paw-product',PawProduct);
  if(!customElements.get('paw-reviews'))customElements.define('paw-reviews',PawReviews);
  document.addEventListener('submit',async e=>{
    const form=e.target.closest('[data-paw-addon],[data-paw-discount]');if(!form)return;e.preventDefault();if(window.PawHabit.busy)return;
    const button=form.querySelector('button'),error=form.querySelector('[data-error]');button.disabled=true;if(error)error.hidden=true;
    try{await updateCart(form.dataset.pawAddon?[{id:Number(form.dataset.pawAddon),quantity:1}]:[],form.dataset.pawDiscount||'',form);}
    catch(err){if(error){error.hidden=false;error.textContent=err.message;}}
    finally{button.disabled=false;}
  });
})();

  } catch(e) { console.error(e); }
})();
})();
